import { render } from "./ProjectSectionStoryProperties.vue?vue&type=template&id=71bb3fd0"
import script from "./ProjectSectionStoryProperties.vue?vue&type=script&lang=js"
export * from "./ProjectSectionStoryProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__